window.app_models.budget = {
    id: null,
    traditional: null,
    notes: null,
    update: null,
    payable_to: null,
    returned_to:null,
    bank_name: null,
    account_number: null,
    routing_number: null,
    first_payment: null,
    pro_rated_start_date: null,
    pro_rated_end_date: null,
    pro_rated_rent: null,
    next_month_start_date: null,
    next_month_end_date: null,
    next_month_rent: null,
    unfurnished_rent: null,
    total_unit_cost: null,
    payable: null,
    invoiceable: null,
    cleaning_fee: null,
    pet_fee: null,
    application_fee: null,
    furniture_cleaning_fee: null,
    furniture_delivery_fee: null,
    renter_ins: null,
    misc_fee: null,
    misc_desc: null,
    landlord_deposit: null,
    landlord_paidby_id: null,
    furniture_deposit: null,
    furniture_paidby_id: null,
    policyholder_needs: null,
    ongoing_rent: null,
    ongoing_payable: null,
    placement_id: null,
    payment_method_id: null,
    ongoing_payment_method_id: null,
    fha_package: null,
    fha_included: null,
    one_time: null,
    one_time_fee: null,
    one_time_tps_fee: null,
    one_time_label: null,
    budget_items: [window.app_models.budget_item],
    budget_markups: [window.app_models.budget_markup],
    payment_requests: [window.app_models.payment_request]
};


// WEBPACK FOOTER //
// ./resources/assets/js/models/budget.js